module.exports = __webpack_public_path__ + "static/trave2-0491719ea06a9f512413ac1d84ebfbc6.jpg";